import { render, staticRenderFns } from "./PearlReport1024.vue?vue&type=template&id=190c83e8&scoped=true"
import script from "./PearlReport1024.vue?vue&type=script&lang=js"
export * from "./PearlReport1024.vue?vue&type=script&lang=js"
import style0 from "./PearlReport1024.vue?vue&type=style&index=0&id=190c83e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c83e8",
  null
  
)

export default component.exports